import Seo from "../components/Seo";
import Hero from "../components/sections/Hero";
import Stats from "../components/sections/Stats";
import Section from "../components/ui-custom/Section";
import ServicesGrid from "../components/sections/ServicesGrid";
import Pricing from "../components/sections/Pricing";
import Features from "../components/sections/Features";
import Dashboard from "../components/sections/Dashboard";
import AboutStory from "../components/sections/AboutStory";
import Testimonials from "../components/sections/Testimonials";
import FAQ from "../components/sections/FAQ";
import CTA from "../components/sections/CTA";
import GlowButton from "../components/ui-custom/GlowButton";
import { ArrowRight } from "lucide-react";
import { Reveal } from "../components/ui-custom/Reveal";

export default function Home() {
  return (
    <>
      <Seo />
      <Hero />
      <Stats />

      <Section eyebrow="Our Services" heading="Everything a digital counter needs" sub="From PAN to banking, recharge to enterprise APIs — all in one platform." center testId="home-services">
        <ServicesGrid limit={9} />
        <Reveal className="mt-10 text-center">
          <GlowButton to="/services" variant="ghost" icon={<ArrowRight size={16} />}>View all services</GlowButton>
        </Reveal>
      </Section>

      <Section eyebrow="Live Dashboard" heading="One glass dashboard for everything" sub="Manage wallet, applications and earnings in real time." center testId="home-dashboard">
        <Dashboard />
      </Section>

      <Section eyebrow="Why utipanagecy" heading="Built for speed, automation & trust" testId="home-features">
        <Features />
      </Section>

      <Section eyebrow="Pricing" heading="Plans for every level of growth" sub="Retailer to White Label — transparent pricing, best margins." center testId="home-pricing">
        <Pricing />
      </Section>

      <Section eyebrow="Our Story" heading="Empowering India's retailers" testId="home-about">
        <AboutStory />
      </Section>

      <Section eyebrow="Testimonials" heading="Loved by retailers across India" center testId="home-testimonials">
        <Testimonials />
      </Section>

      <Section eyebrow="FAQ" heading="Frequently asked questions" center testId="home-faq">
        <FAQ />
      </Section>

      <CTA />
    </>
  );
}
